import React from 'react'
import { NewPurchaseOrderWizard } from '../wizard/NewPurchaseOrderWizard'

interface NewPurchaseOrderModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const NewPurchaseOrderModal: React.FC<NewPurchaseOrderModalProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <NewPurchaseOrderWizard
      open={open}
      onOpenChange={onOpenChange}
      documentType="orden-compra"
    />
  )
}

export default NewPurchaseOrderModal
